const c = {
  name: "Pos",
  dimensions: { width: 22, height: 40 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 22 40" style="enable-background:new 0 0 22 40;" xml:space="preserve">
<style type="text/css">
	.st0{fill: currentColor;}
</style>
<g>
	<g>
		<path class="st0" d="M8.3,21c0,0.7-0.6,1.2-1.2,1.2S5.8,21.7,5.8,21c0-0.7,0.6-1.2,1.2-1.2S8.3,20.3,8.3,21z"/>
		<path class="st0" d="M11,22.3c0.7,0,1.2-0.6,1.2-1.2c0-0.7-0.6-1.2-1.2-1.2c-0.7,0-1.3,0.6-1.3,1.2C9.8,21.7,10.3,22.3,11,22.3z"
			/>
		<path class="st0" d="M16.3,21c0,0.7-0.6,1.2-1.3,1.2c-0.7,0-1.2-0.6-1.2-1.2c0-0.7,0.6-1.2,1.2-1.2C15.7,19.8,16.3,20.3,16.3,21z"
			/>
		<path class="st0" d="M7,26.3c0.7,0,1.2-0.6,1.2-1.2c0-0.7-0.6-1.2-1.2-1.2S5.8,24.3,5.8,25C5.8,25.7,6.3,26.3,7,26.3z"/>
		<path class="st0" d="M12.3,25c0,0.7-0.6,1.2-1.2,1.2c-0.7,0-1.3-0.6-1.3-1.2c0-0.7,0.6-1.2,1.3-1.2C11.7,23.8,12.3,24.3,12.3,25z"
			/>
		<path class="st0" d="M15,26.3c0.7,0,1.3-0.6,1.3-1.2c0-0.7-0.6-1.2-1.3-1.2c-0.7,0-1.2,0.6-1.2,1.2C13.8,25.7,14.3,26.3,15,26.3z"
			/>
		<path class="st0" d="M8.3,29c0,0.7-0.6,1.2-1.2,1.2S5.8,29.7,5.8,29c0-0.7,0.6-1.2,1.2-1.2S8.3,28.3,8.3,29z"/>
		<path class="st0" d="M11,30.3c0.7,0,1.2-0.6,1.2-1.2c0-0.7-0.6-1.2-1.2-1.2c-0.7,0-1.3,0.6-1.3,1.2C9.8,29.7,10.3,30.3,11,30.3z"
			/>
		<path class="st0" d="M16.3,29c0,0.7-0.6,1.2-1.3,1.2c-0.7,0-1.2-0.6-1.2-1.2c0-0.7,0.6-1.2,1.2-1.2C15.7,27.8,16.3,28.3,16.3,29z"
			/>
		<path class="st0" d="M3,0C1.3,0,0,1.3,0,3v29c0,1.7,1.3,3,3,3v2c0,1.7,1.3,3,3,3h10c1.7,0,3-1.3,3-3v-2c1.7,0,3-1.3,3-3V3
			c0-1.7-1.3-3-3-3H3z M5,35h12v2c0,0.5-0.5,1-1,1H6c-0.5,0-1-0.5-1-1V35z M2,32V17h18v15c0,0.5-0.5,1-1,1H3C2.5,33,2,32.5,2,32z
			 M2,15V3c0-0.5,0.5-1,1-1h16c0.5,0,1,0.5,1,1v12H2z"/>
	</g>
</g>
</svg>
  `
};
export {
  c as Pos
};
